import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { HttpService } from './services/http.service';
import { AnalyticsService } from './services/analytics.service';
import { ApplicationInsightsService } from './services/application-insights.service';
import { AppConfigurationService } from './services/configuration/app-configuration.service';

@NgModule({
  imports: [
    HttpClientModule
  ],
  declarations: []
})
export class CrosscuttingModule {
  static forRoot(): ModuleWithProviders<CrosscuttingModule> {
    return {
      ngModule: CrosscuttingModule,
      providers: [
        AnalyticsService,
        ApplicationInsightsService,
        AppConfigurationService,
        HttpService
      ],
    };
  }
}

